var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouncil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1643 54.7498H31.4977V21.1664M31.4977 21.1664C34.3511 21.1664 36.6643 18.8532 36.6643 15.9998C36.6643 15.379 36.5549 14.7838 36.3541 14.2324M31.4977 21.1664C28.6442 21.1664 26.331 18.8532 26.331 15.9998C26.331 13.1463 28.6442 10.8331 31.4977 10.8331C33.7304 10.8331 35.6323 12.2493 36.3541 14.2324M26.6438 17.7667L12.0785 23.068M50.9191 8.93115L36.3541 14.2324M15.9977 54.7498C19.9051 54.7498 23.1371 52.5757 23.6705 48.9406C23.7043 48.7102 23.7212 48.595 23.7079 48.3395C23.6988 48.1631 23.639 47.8408 23.5843 47.6728C23.5051 47.4296 23.409 47.2588 23.2169 46.9172L15.9977 34.0831L8.7785 46.9172C8.60037 47.2339 8.5113 47.3922 8.42892 47.6672C8.37824 47.8365 8.31959 48.2425 8.32032 48.4192C8.32151 48.7063 8.33889 48.782 8.37365 48.9336C9.03231 51.8048 12.1952 54.7498 15.9977 54.7498ZM46.9977 44.4164C50.9051 44.4164 54.1371 42.2424 54.6705 38.6073C54.7043 38.3769 54.7212 38.2617 54.7079 38.0062C54.6988 37.8298 54.639 37.5074 54.5843 37.3395C54.5051 37.0962 54.409 36.9254 54.2169 36.5839L46.9977 23.7498L39.7785 36.5839C39.6004 36.9005 39.5113 37.0589 39.4289 37.3339C39.3782 37.5031 39.3196 37.9092 39.3203 38.0858C39.3215 38.3729 39.3389 38.4487 39.3736 38.6002C40.0323 41.4714 43.1952 44.4164 46.9977 44.4164Z",
    stroke: "url(#paint0_linear_7323_23416)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7323_23416",
    x1: 8.32031,
    y1: 31.8405,
    x2: 54.7125,
    y2: 31.8405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#992FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D73FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouncil);
export default __webpack_public_path__ + "static/media/council.935b3357397f6d1606f2ebf5ddaa5a10.svg";
export { ForwardRef as ReactComponent };